// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const menuItemClasses = {
  command: "qui-menu-item__command",
  group: "qui-menu-item__group",
  groupLabel: "qui-menu-item__group-label",
  icon: "qui-menu-item__icon",
  itemAccessory: "qui-menu-item__accessory",
  itemDescription: "qui-menu-item__description",
  itemIndicator: "qui-menu-item__indicator",
  itemLabel: "qui-menu-item__label",
  root: "qui-menu-item__root",
  startIcon: "qui-menu-item__start-icon",
} as const
